package com.essntl.core.quickbooks.data

import kotlinx.serialization.Serializable

@Serializable
data class QuickbooksCategoryDto(
    val Item: QuickbooksCategory,
    val time: String,
)

@Serializable
data class QuickbooksCategory(
    val FullyQualifiedName: String,
    val domain: String?,
    val Name: String,
    val SyncToken: String,
    val sparse: Boolean?,
    val Active: Boolean?,
    val Type: String?,
    val Id: String,
    val MetaData: QuickbooksCategoryMetaData?,
)

@Serializable
data class QuickbooksCategoryMetaData(
    val CreateTime: String? = null,
    val LastUpdatedTime: String? = null,
)